import { Data } from "dataclass";
import { TripDto } from "../../../Global/models/TripDto";
import {
  formatTripDateRangeToDateAndMonth,
} from "../../../utils/DateUtils";

export class SpotFormViewModel extends Data {
  tripId: string = "";
  tripName: string = "";
  tripOptionDates: string[] = [];
  tripDates: any[] = [];
}

export const mapToSpotFormViewModel = (tripDto: TripDto) => {
  return SpotFormViewModel.create({
    tripId: tripDto.id,
    tripName: tripDto.tripName,
    tripOptionDates: tripDto.tripDates.map((range) =>
      formatTripDateRangeToDateAndMonth(range)
    ),
    tripDates: tripDto.tripDates,
  });
};
